/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import apicache from "../../../components/clearCach/clear";
import { fetchDate } from "../../../utils/globleFunc";
import {
  Volume2,
  Check,
  Info,
  Upload,
  X,
  RefreshCw,
  Lock,
  Settings,
  AlertTriangle,
  VolumeX,
  Activity,
} from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ActivationPageSpeak({ close }) {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const products = useSelector((state) => state.ProductsReducer);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [isPageSpeakActive, setIsPageSpeakActive] = useState(false);
  const { t } = useTranslation();

  const [data, setData] = useStoreFormDraft(store);

  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    if (store) {

      setIsPageSpeakActive(Boolean(store.speakpageP));
    }
  }, [store]);

  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();
    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000);
    return () => clearInterval(interval);
  }, []);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.pageSpeak.alert.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.pageSpeak.alert.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleDChange = () => {
    setData({ ...data, speakpageP: !data.speakpageP });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if we're activating or deactivating
    const isActivating = data.speakpageP && !isPageSpeakActive;
    const isDeactivating = !data.speakpageP && isPageSpeakActive;
    const noChange = data.speakpageP === isPageSpeakActive;

    // If no change, don't do anything
    if (noChange) {
      await showAlert(
        "info",
        t("servicePageActivation.pageSpeak.alert.noChange.title"),
        t("servicePageActivation.pageSpeak.alert.noChange.text")
      );
      return;
    }

    if (isDeactivating) {
      // If deactivating, confirm with user
      const result = await showAlert(
        "warning",
        t("servicePageActivation.pageSpeak.alert.deactivateConfirm.title"),
        t("servicePageActivation.pageSpeak.alert.deactivateConfirm.text"),
        true,
        t("servicePageActivation.pageSpeak.alert.deactivateConfirm.confirmText")
      );

      // If user cancels the confirmation, stop the process
      if (!result.isConfirmed) {
        // Reset toggle to previous state
        setData({ ...data, speakpageP: true });
        return;
      }
    }

    try {
      setLoading(true);
      await apicache(account, products);

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);
      setIsPageSpeakActive(data.speakpageP);

      if (isDeactivating) {
        await showAlert(
          "success",
          t("servicePageActivation.pageSpeak.alert.activationSuccess.title")
        );
      } else if (isActivating) {
        await showAlert(
          "success",
          t("servicePageActivation.pageSpeak.alert.activationSuccess.title")
        );
      }
      close();
    } catch (error) {
      setLoading(false);

      if (isDeactivating) {
        await showAlert(
          "error",
          t("servicePageActivation.pageSpeak.alert.deactivationError.title"),
          t("servicePageActivation.pageSpeak.alert.deactivationError.text")
        );
      } else {
        await showAlert(
          "error",
          t("servicePageActivation.pageSpeak.alert.deactivationError.title"),
          t("servicePageActivation.pageSpeak.alert.deactivationError.text")
        );
      }

      console.error("Error saving PageSpeak settings:", error);
    }
  };

  const handleRemoveAudio = () => {
    setData({ ...data, vcl: "" });
  };

  const uploadVocal = async (files) => {
    if (!files || !files.length) return;

    setUploadLoading(true);

    for (let i = 0; i < files.length; i++) {
      const formData = new FormData();
      formData.append("upload", files[i]);

      try {
        const response = await axios.post(
          "https://octopus-app-i4ylg.ondigitalocean.app/upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        setData({ ...data, vcl: response.data.url });

        await showAlert("success", "تم رفع الملف الصوتي بنجاح");
      } catch (error) {
        console.error("Error uploading audio file:", error);

        await showAlert(
          "error",
          "فشل رفع الملف",
          "حدثت مشكلة أثناء رفع الملف الصوتي. يرجى المحاولة مرة أخرى."
        );
      } finally {
        setUploadLoading(false);
      }
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.pageSpeak.alert.payant.title"),
      t("servicePageActivation.pageSpeak.alert.payant.text"),
      true,
      t("servicePageActivation.pageSpeak.alert.payant.confirm")
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };

  // If feature is locked, show lock screen
  if (store.speakpage === false) {
    return (
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] text-center">
          <div className="py-8">
            <div className="mb-4 flex justify-center">
              <div className="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center">
                <Lock size={36} className="text-yellow-500" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#9e68ba] mb-3">
              {t("servicePageActivation.pageSpeak.locked.title")}
            </h3>
            <p className="text-gray-600 mb-6 max-w-md mx-auto">
              {t("servicePageActivation.pageSpeak.locked.description")}
            </p>
            <button
              onClick={handlePay}
              className="px-5 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors"
            >
              {t("servicePageActivation.pageSpeak.locked.cta")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] rounded-xl shadow-sm p-6 border border-[#fbf4ff]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
            <Volume2 className="ml-2" size={20} />
            {t("servicePageActivation.pageSpeak.title")}
          </h3>
          <p className="text-gray-600 dark:!text-gray-400">
            {t("servicePageActivation.pageSpeak.description")}
          </p>
        </div>

        {/* Service Status Indicator */}
        <div
          className={`mb-4 p-3 rounded-lg ${
            isPageSpeakActive
              ? "bg-green-50 border border-green-200 dark:!bg-green-900 dark:!border-green-700"
              : "bg-gray-50 border border-gray-200 dark:!bg-[#141414] dark:!border-[#3c3a3d]"
          }`}
        >
          <div className="flex items-center gap-x-2">
            <div
              className={`w-3 h-3 rounded-full mr-2 ${
                isPageSpeakActive
                  ? "bg-green-500 dark:!bg-green-400"
                  : "bg-gray-400 dark:!bg-gray-500"
              }`}
            ></div>
            <span
              className={`text-sm font-medium ${
                isPageSpeakActive
                  ? "text-green-700 dark:!text-green-300"
                  : "text-gray-700 dark:!text-gray-400"
              }`}
            >
              {isPageSpeakActive
                ? t("servicePageActivation.pageSpeak.status.active")
                : t("servicePageActivation.pageSpeak.status.inactive")}
            </span>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Enable PageSpeak Toggle */}
          <div className="mb-6">
            <div className="flex justify-between items-center mb-4">
              <label className="block text-sm font-medium text-[#9e68ba]">
                {t("servicePageActivation.pageSpeak.toggle.label")}
              </label>
              <div
                className={`px-2 py-1 rounded-full text-xs font-medium ${
                  data.speakpageP
                    ? "bg-green-100 text-green-800 dark:!bg-green-900 dark:!text-green-300"
                    : "bg-gray-100 text-gray-800 dark:!bg-[#2c2c2c] dark:!text-gray-400"
                }`}
              >
                {data.speakpageP
                  ? t("servicePageActivation.pageSpeak.toggle.active")
                  : t("servicePageActivation.pageSpeak.toggle.inactive")}
              </div>
            </div>
            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${
                data.speakpageP
                  ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#2a2030] dark:!border-purple-700"
                  : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#141414] dark:!border-[#3c3a3d] dark:hover:!bg-[#1e1e1e]"
              }`}
              onClick={handleDChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <input
                  type="checkbox"
                  checked={data.speakpageP}
                  onChange={() => {}}
                  className="hidden"
                  id="toggle"
                />
                <label
                  htmlFor="toggle"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${
                    data.speakpageP ? "bg-purple-400" : ""
                  }`}
                >
                  <span
                    className={`block h-6 w-6 bg-white rounded-full shadow transform transition-transform duration-200 ${
                      data.speakpageP
                        ? "rtl:-translate-x-6 ltr:translate-x-6"
                        : "translate-x-0"
                    }`}
                  />
                </label>
              </div>
              <div>
                <div className="flex items-center">
                  {data.speakpageP ? (
                    <Volume2 size={18} className="ml-2 text-[#9e68ba]" />
                  ) : (
                    <VolumeX
                      size={18}
                      className="ml-2 text-gray-500 dark:!text-gray-400"
                    />
                  )}
                  <p className="font-medium">
                    {data.speakpageP
                      ? t("servicePageActivation.pageSpeak.toggle.enabledTitle")
                      : t(
                          "servicePageActivation.pageSpeak.toggle.disabledTitle"
                        )}
                  </p>
                </div>
                <p className="text-sm text-gray-500 dark:!text-gray-400 mt-1">
                  {data.speakpageP
                    ? t(
                        "servicePageActivation.pageSpeak.toggle.enabledDescription"
                      )
                    : t(
                        "servicePageActivation.pageSpeak.toggle.disabledDescription"
                      )}
                </p>
              </div>
            </div>
          </div>

          {/* Tips Section */}
          <div className="mb-6 bg-blue-50 p-4 rounded-lg border border-blue-100 dark:!bg-[#0d2438] dark:!border-[#1e3a5c]">
            <h4 className="font-medium text-lg text-blue-800 dark:!text-blue-300 mb-2 flex items-center">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.pageSpeak.tips.title")}
            </h4>
            <ul className="text-sm text-gray-700 dark:!text-gray-300 space-y-2 mr-5 list-disc">
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Volume2 size={14} className="text-blue-600 mt-1" />
                </span>
                <span>{t("servicePageActivation.pageSpeak.tips.list.0")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Check size={14} className="text-blue-600 mt-1" />
                </span>
                <span>{t("servicePageActivation.pageSpeak.tips.list.1")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Settings size={14} className="text-blue-600 mt-1" />
                </span>
                <span>{t("servicePageActivation.pageSpeak.tips.list.2")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Activity size={14} className="text-blue-600 mt-1" />
                </span>
                <span>{t("servicePageActivation.pageSpeak.tips.list.3")}</span>
              </li>
            </ul>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading || data.speakpageP === isPageSpeakActive}
            className={`px-6 py-3 ${
              data.speakpageP !== isPageSpeakActive
                ? data.speakpageP
                  ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                  : "bg-red-500 hover:bg-red-600"
                : "bg-gray-400 dark:!bg-gray-600"
            } text-white rounded-lg transition-colors flex items-center justify-center ${
              loading || data.speakpageP === isPageSpeakActive
                ? "opacity-70 cursor-not-allowed"
                : ""
            }`}
          >
            {loading ? (
              <>
                <RefreshCw className="animate-spin ml-2" size={18} />
                {data.speakpageP
                  ? t("servicePageActivation.pageSpeak.button.enabling")
                  : t("servicePageActivation.pageSpeak.button.disabling")}
              </>
            ) : (
              <>
                {data.speakpageP !== isPageSpeakActive ? (
                  data.speakpageP ? (
                    <>
                      <Check className="ml-2" size={18} />
                      {t("servicePageActivation.pageSpeak.button.enable")}
                    </>
                  ) : (
                    <>
                      <X className="ml-2" size={18} />
                      {t("servicePageActivation.pageSpeak.button.disable")}
                    </>
                  )
                ) : (
                  <>
                    <Info className="ml-2" size={18} />
                    {t("servicePageActivation.pageSpeak.button.noChange")}
                  </>
                )}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
